import { render } from "./AbstractTable.vue?vue&type=template&id=4fba3264"
import script from "./AbstractTable.vue?vue&type=script&lang=js"
export * from "./AbstractTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__